<template>
    <div class="currency-container">
        <div class="currency-header">
            <span class="currency-add">Benefits</span>
            <v-tooltip bottom>
                <v-btn flat color="black" slot="activator" @click="addBenefitItem" class="item-add-button-icon">
                    <v-icon large color="indigo">mdi-plus</v-icon>
                </v-btn>
                <div>Add new benefit</div>
            </v-tooltip>
        </div>
        <div>
            <AppTable :data="benefitsData" :owner="'type'" :saving="saving"
                @deleteItem="deleteBenefitItem" @saveItem="saveBenefit" @cancelEdit="cancelEditBenefitItem"
                @editItem="editBenefitItem" class="currency-table" />
        </div>
     </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';

    import AppTable from '@/components/common/AppTable';

    export default {
        name: 'benefit-settings',
        components: {
            AppTable
        },
        data() {
            return {
                saving: false
            };
        },
        computed: {
            ...mapGetters({ benefits: 'getBenefits' }),
            benefitsData() {
                return {
                    items: [
                        ...this.benefits
                    ]
                };
            }
        },
        methods: {
            ...mapActions([
                'deleteBenefit',
                'addBenefit',
                'editBenefit',
                'cancelBenefitEdit',
                'changeBenefit',
                'createNewBenefit'
            ]),
            deleteBenefitItem(index) {
                this.deleteBenefit(index);
            },
            addBenefitItem() {
                this.addBenefit({
                    id: -1,
                    name: '',
                    editting: true,
                    editable: true
                });
            },
            editBenefitItem(facilityTypeId) {
                this.editBenefit(facilityTypeId);
            },
            cancelEditBenefitItem() {
                this.cancelBenefitEdit();
            },
            saveBenefit(payload) {
                this.saving = true;
                if (payload.id > 0) {
                    this.changeBenefit(payload).then(() => {
                        this.saving = false;
                    });
                } else {
                    this.createNewBenefit(payload.name).then(() => {
                        this.saving = false;
                    });
                }
            }
        }
    };
</script>
<style scoped>
.currency-container {
    padding-bottom: 26px;
}

.currency-header {
    font-size: 24px;
    padding-left: 24px;
    padding-bottom: 14px;
    margin-top: 10px;
}

.currency-table {
    margin: 0 26px;
}

.currency-add {
    margin-right: 15px;
}

@media screen and (max-width: 600px) {
    .currency-table {
        margin: 0 13px;
    }
    
    .card__text {
        padding-left: 8px;
        padding-right: 8px;
    }

    .currency-header {
        font-size: 14px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/BenefitSettings.vue